/* ========================================================================
   INFORMATIONS GÉNÉRALES SUR LE SITE
   Propriété de © 2019/2024 Shopiweb.fr
   Pour plus d'informations, visitez : https://www.shopiweb.fr
   ======================================================================== */

/* =====================
   LPFR (12/10/2026) - Correctif pagination infinie
   Le gabarit place la description AVANT les produits dans le HTML (SEO)
   puis l'affiche SOUS la grille (CSS order). Sans la règle ci-dessous,
   le navigateur prend la description comme point d'ancrage : à chaque
   chargement de page, il fait défiler l'écran de toute la hauteur des
   produits ajoutés, ce qui déclenche la page suivante, et ainsi de suite
   jusqu'à la fin de la collection (le client se retrouve au dernier produit).
   NE PAS SUPPRIMER.
   ===================== */
(() => {
  if (document.getElementById("lpfr-scroll-anchor-fix")) return;
  const style = document.createElement("style");
  style.id = "lpfr-scroll-anchor-fix";
  style.textContent =
    ".collection-description-block,#paging-collection,.collection-page-of,.collection-page-of + small{overflow-anchor:none}";
  document.head.appendChild(style);
})();

/* =====================
   Recharger l'ensemble de la collection de produits avec un contenu actualisé
   ===================== */
const reloadCollection = async () => {
  const productListing = document.querySelector(".collection .product-listing");

  if (productListing) {
    productListing.style.opacity = "0.2";
  }

  window.scrollTo({ top: 0, behavior: "smooth" });

  const response = await fetch(window.location.href);
  const htmlContent = await response.text();
  const parser = new DOMParser();
  const updatedDocument = parser.parseFromString(htmlContent, "text/html");

  // Replace the main product collection with its updated version
  const updatedCollection = updatedDocument.querySelector(".collection");
  if (updatedCollection) {
    document.querySelector(".collection")?.replaceWith(updatedCollection);
    productListing.style.opacity = "1";
  }

  // Update additional UI components related to the collection
  updateUIComponents(updatedDocument);

  // Reinitialize Bootstrap popovers in the collection
  document
    .querySelectorAll('.collection [data-bs-toggle="popover"]')
    .forEach((el) => {
      bootstrap.Popover.getOrCreateInstance(el);
    });

  // Notify the application that the collection has been updated
  window.dispatchEvent(new CustomEvent("onCollectionShopiwebUpdate"));
};

// Updates filter components and other interactive elements within the offcanvas filters
const updateUIComponents = (updatedDocument) => {
  // Update collapsible filter internals
  document
    .querySelectorAll("#offcanvas-filters .collapse-inner")
    .forEach((collapse) => {
      const collapseId = collapse.closest(".collapse").getAttribute("id");
      const newCollapseContent = updatedDocument.querySelector(
        `#offcanvas-filters #${collapseId} .collapse-inner`
      );
      if (newCollapseContent) {
        collapse.replaceWith(newCollapseContent);
      }
    });

  // Replace specific filter UI components such as footer, clear all button, and sort by selector
  const uiSelectors = [
    "#offcanvas-filters .offcanvas-footer",
    "#offcanvas-filters .btn-filters-clear-all",
    '#offcanvas-filters [name="sort_by"]',
  ];
  uiSelectors.forEach((selector) => {
    const newElement = updatedDocument.querySelector(selector);
    document.querySelector(selector)?.replaceWith(newElement);
  });
};

/* =====================
   Utilitaire pour mettre à jour l'URL avec de nouveaux paramètres de requête
   ===================== */
const updateUrlWithQueryParams = (form) => {
  const params = new URLSearchParams(new FormData(form));
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState({}, "", newUrl);
};

/* =====================
   Mise à jour de la collection en fonction des changements de filtre
   ===================== */
window.onChangeCollectionFilter = async (inputElement) => {
  const form = inputElement.closest("form");
  updateUrlWithQueryParams(form);
  await reloadCollection();
};

/* =====================
   Gestion des changements de filtres de prix de la collection
   ===================== */
const setupPriceFilterListeners = () => {
  document.querySelectorAll(".filter-amounts input").forEach((input) => {
    input.addEventListener(
      "input",
      window.debounce(async () => {
        updateUrlWithQueryParams(input.closest("form"));
        await reloadCollection();
      }, 750)
    );
  });
};
setupPriceFilterListeners();
window.addEventListener(
  "onCollectionShopiwebUpdate",
  setupPriceFilterListeners
);

/* =====================
   Développe tous les filtres cachés en cliquant sur le bouton
   ===================== */
window.onClickFiltersViewMore = (button) => {
  button
    .closest(".collapse")
    .querySelectorAll(".form-check")
    .forEach((check) => {
      check.removeAttribute("hidden");
    });
  button.remove();
};

/* =====================
   Efface tous les filtres et recharge la collection
   ===================== */
window.onClickClearAllFilters = async (button) => {
  const form = button.closest("form");
  const sortValue = form.querySelector('[name="sort_by"]').value;
  const params = new URLSearchParams();
  params.set("sort_by", sortValue);
  window.history.replaceState(
    {},
    "",
    `${window.location.pathname}?${params.toString()}`
  );
  await reloadCollection();
};

/* =====================
   Initialise les curseurs du filtre de prix
   ===================== */
const initializePriceFilterSliders = () => {
  document.querySelectorAll(".amount-selection-slider").forEach((slider) => {
    const minValueField = slider
      .closest("form")
      .querySelector('[name="filter.v.price.gte"]');
    const maxValueField = slider
      .closest("form")
      .querySelector('[name="filter.v.price.lte"]');

    if (slider.noUiSlider) {
      slider.noUiSlider.destroy();
    }

    noUiSlider.create(slider, {
      start: [Number(slider.dataset.minValue), Number(slider.dataset.maxValue)],
      connect: true,
      range: {
        min: Number(slider.dataset.rangeMin),
        max: Number(slider.dataset.rangeMax),
      },
    });

    slider.noUiSlider.on("update", (values) => {
      minValueField.value = values[0];
      maxValueField.value = values[1];
    });

    slider.noUiSlider.on("change", () => {
      minValueField.dispatchEvent(new Event("input"));
      maxValueField.dispatchEvent(new Event("input"));
    });
  });
};
initializePriceFilterSliders();
window.addEventListener(
  "onCollectionShopiwebUpdate",
  initializePriceFilterSliders
);

/* =====================
   Met à jour les paramètres de l'URL
   ===================== */
const updateQueryParameters = (key, value) => {
  const params = new URLSearchParams(window.location.search);
  params.set(key, value);
  return `${window.location.pathname}?${params.toString()}`;
};

/* =====================
   Gère les changements dans le tri de la collection
   ===================== */
window.onChangeCollectionSortBy = (sortByValue) => {
  const updatedUrl = updateQueryParameters("sort_by", sortByValue);
  window.history.replaceState({}, "", updatedUrl);
  reloadCollection();
};

/* =====================
   Fonctions permettant de charger d'autres produits dans une collection à la suite d'une action de l'utilisateur.
   LPFR (12/10/2026) : réécrites.
   - l'adresse de la page n'est plus modifiée (plus de ?page=2, ?page=3...)
   - seule la section produits est téléchargée (section_id), pas la page entière
   - l'écran reste sur les produits que le client regarde
   - le bouton « Charger les précédents » et les compteurs sont mis à jour
   - verrou : une seule page chargée à la fois
   ===================== */
const showLoadingIndicator = (button) => {
  button.style.width = `${button.offsetWidth + 2}px`;
  button.style.height = `${button.offsetHeight + 2}px`;
  button.innerHTML = `
        <div class="spinner-border mx-auto spinner-border-sm" style="width: 1.2rem; height: 1.2rem" role="status">
            <span class="visually-hidden">En attente...</span>
        </div>
    `;
};

let lpfrCollectionLoading = false;

const getCollectionSectionId = () => {
  const section = document
    .querySelector(".collection")
    ?.closest('[id^="shopify-section-"]');
  return section ? section.id.replace("shopify-section-", "") : null;
};

// Lit « Affichage de 1–48 sur 400 » -> {start, end, total}
const parseRangeText = (el) => {
  const m = el?.textContent.match(/(\d+)\s*[–-]\s*(\d+)\D+(\d+)/);
  return m ? { start: +m[1], end: +m[2], total: +m[3] } : null;
};

const updateCollectionContent = async (button, direction) => {
  if (lpfrCollectionLoading) return;
  lpfrCollectionLoading = true;

  const url = button.dataset[direction + "Url"];

  try {
    const sectionId = getCollectionSectionId();
    const fetchUrl = sectionId
      ? url + (url.includes("?") ? "&" : "?") + "section_id=" + encodeURIComponent(sectionId)
      : url;

    const response = await fetch(fetchUrl);
    if (!response.ok) throw new Error("HTTP " + response.status);
    const data = await response.text();
    const newDocument = new DOMParser().parseFromString(data, "text/html");

    const productListSelector = ".collection .product-listing";
    const list = document.querySelector(productListSelector);
    const newList = newDocument.querySelector(productListSelector);
    if (!list || !newList) throw new Error("liste introuvable");

    // Produit de référence : il doit rester exactement au même endroit à l'écran
    const ref = direction === "next" ? list.lastElementChild : list.firstElementChild;
    const refTop = ref ? ref.getBoundingClientRect().top : null;

    list.insertAdjacentHTML(
      direction === "next" ? "beforeend" : "afterbegin",
      newList.innerHTML
    );

    if (ref && refTop !== null) {
      const delta = ref.getBoundingClientRect().top - refTop;
      if (Math.abs(delta) > 1) {
        window.scrollTo({ top: window.scrollY + delta, behavior: "instant" });
      }
    }

    // Compteurs « Page X sur Y » et « Affichage de A–B sur T »
    const pageOf = document.querySelector(".collection .collection-page-of");
    const newPageOf = newDocument.querySelector(".collection .collection-page-of");
    const range = pageOf?.nextElementSibling;
    const newRange = newPageOf?.nextElementSibling;
    const r1 = parseRangeText(range);
    const r2 = parseRangeText(newRange);

    if (direction === "next") {
      // Bouton « Charger plus » + barre de progression de la nouvelle page
      const paging = document.querySelector("#paging-collection");
      const newPaging = newDocument.querySelector("#paging-collection");
      if (paging && newPaging) paging.replaceWith(newPaging);
      if (pageOf && newPageOf) pageOf.textContent = newPageOf.textContent;
      if (range && r1 && r2) range.textContent = `Affichage de ${r1.start}–${r2.end} sur ${r2.total}`;
    } else {
      // Bouton « Charger les précédents » de la page chargée (masqué s'il n'y en a plus)
      const prevBtn = document.querySelector("#btn-load-previous");
      const newPrevBtn = newDocument.querySelector("#btn-load-previous");
      if (prevBtn && newPrevBtn) prevBtn.replaceWith(newPrevBtn);
      if (range && r1 && r2) range.textContent = `Affichage de ${r2.start}–${r1.end} sur ${r1.total}`;
    }

    document
      .querySelectorAll('.collection [data-bs-toggle="popover"]')
      .forEach((el) => {
        bootstrap.Popover.getOrCreateInstance(el);
      });

    window.dispatchEvent(new CustomEvent("onCollectionShopiwebUpdate"));
  } catch (error) {
    // En cas d'échec, on ouvre la page demandée normalement plutôt que de bloquer le client
    window.location.href = url;
  } finally {
    lpfrCollectionLoading = false;
  }
};

window.onClickCollectionLoadMore = async (button, event) => {
  event.preventDefault();
  if (lpfrCollectionLoading) return;
  showLoadingIndicator(button);
  await updateCollectionContent(button, "next");
};

window.onClickCollectionLoadPrevious = async (button, event) => {
  event.preventDefault();
  if (lpfrCollectionLoading) return;
  showLoadingIndicator(button);
  await updateCollectionContent(button, "previous");
};

/* =====================
   Pagination infinie automatique
   LPFR : un seul observateur actif à la fois
   ===================== */
let lpfrPagingObserver = null;

const initializeAutoPagination = () => {
  if (lpfrPagingObserver) {
    lpfrPagingObserver.disconnect();
    lpfrPagingObserver = null;
  }

  const pagination = document.querySelector("#paging-collection");
  if (!pagination) return;

  const observerOptions = { threshold: 0, rootMargin: "0px 0px -100px 0px" };
  lpfrPagingObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !lpfrCollectionLoading) {
        const loadMoreButton = pagination.querySelector(".button-loading-more");
        if (loadMoreButton) loadMoreButton.click();
      }
    });
  }, observerOptions);

  lpfrPagingObserver.observe(pagination);
};

initializeAutoPagination();
window.addEventListener("onCollectionShopiwebUpdate", initializeAutoPagination);

// Attaches or detaches a sticky utilities bar based on scroll position
const toggleStickyUtilitiesBar = () => {
  const utilitiesBar = document.querySelector("#collection-controls");
  if (!utilitiesBar) return;

  const navbarHeight =
    document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0;
  const announcementBarHeight =
    document.querySelector('[id*="__announcement-bar"].sticky-top')
      ?.clientHeight || 0;
  const stickyTriggerHeight = 700; // Adjusted fixed value for when to trigger sticky behavior

  const adjustStickyStatus = () => {
    if (window.scrollY > stickyTriggerHeight) {
      utilitiesBar.classList.add("sticky-top");
      utilitiesBar.style.top = `${navbarHeight + announcementBarHeight}px`;
      setTimeout(() => utilitiesBar.classList.add("show"), 200);
    } else {
      utilitiesBar.classList.remove("show");
      setTimeout(() => {
        utilitiesBar.classList.remove("sticky-top");
        utilitiesBar.style.top = "0";
      }, 200);
    }
  };

  // Throttling the scroll event listener to improve performance
  const throttledAdjust = window.throttle(adjustStickyStatus, 200);
  document.addEventListener("scroll", throttledAdjust);

  // Periodic check to reset sticky status near the top of the page
  setInterval(() => {
    if (window.scrollY < 50) {
      utilitiesBar.classList.remove("sticky-top", "show");
      utilitiesBar.style.top = "0";
    }
  }, 1000);
};

// Initialize the sticky utilities bar logic
toggleStickyUtilitiesBar();

// Re-initialize sticky utilities bar when the collection updates
window.addEventListener("onCollectionShopiwebUpdate", () => {
  setTimeout(toggleStickyUtilitiesBar, 1000);
});

// This function reveals all color swatches for a product and removes the trigger button
window.showCompleteSwatchSet = (triggerButton, event) => {
  const swatchContainer = triggerButton.closest(".color-swatches");
  swatchContainer.querySelectorAll("li").forEach((swatch) => {
    swatch.removeAttribute("hidden");
  });
  triggerButton.remove();
};

/* =====================
   Bannière de collection
   ===================== */
const initializeCollectionBanners = () => {
  const productListing = document.querySelector(".collection .product-listing");

  if (!productListing) return;

  // Process each banner and insert it before the specified product item
  document.querySelectorAll(".collection-card").forEach((b) => {
    const injectionIndex = Number(b.dataset.inject) - 1;
    const targetItem = productListing.children[injectionIndex];

    if (targetItem) {
      targetItem.insertAdjacentElement("beforebegin", b);
    }
  });
};
initializeCollectionBanners();

// Handle the loading of Shopify sections which might include collection banners
document.addEventListener("shopify:section:load", (event) => {
  if (event.target.querySelector(".collection-card")) {
    // Re-initialize banners upon dynamic content loading to ensure correct placement
    initializeCollectionBanners();
  }
});
